module.exports = require("@material-ui/core/FormControlLabel");